const CommonApi = {
    sendFeedback(data) {
        return axios.post("/feedback", data, { "content-type": "multipart/form-data" });
    },

    getStaticPage(type) {
        return axios.get(`/infos/${type}`).then(resp => resp.data.success);
    },

    getSiteInfo() {
        return axios.get("header").then(resp => resp.data.success);
    },

    updateSiteInfo(data) {
        return axios.post("admin/header", data, { "content-type": "multipart/form-data" });
    },
};

export default CommonApi;
